module.exports = __webpack_public_path__ + "img/NO937904673.f16bb47d.png";